"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnnouncementMessage = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

require("./PulseAnnouncementMessage.scss");

require("./PulseMessage.scss");

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _Accordion = require("@react/react-spectrum/Accordion");

var _IconMapper = _interopRequireDefault(require("./../icons/IconMapper"));

var _PulseApiHelper = _interopRequireDefault(require("../../service/PulseApiHelper"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var _Constants = require("../../constants/Constants");

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseAnnouncementMessage"));

var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var MessageHeader = function MessageHeader(props) {
  var pulseMessageObject = props.pulseMessageObject;
  var title = "".concat(pulseMessageObject.serviceName.replace('Adobe', ''), " - ");
  var subtitle = "".concat(pulseMessageObject.eventType, " - ");
  var productRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showProductNameTooltip = _useState2[0],
      setshowProductNameTooltip = _useState2[1];

  (0, _react.useEffect)(function () {
    setshowProductNameTooltip(_PulseUtil.default.isTextOverFlown(productRef));
  }, []);
  return _react.default.createElement("div", {
    className: "pulse-announcement-message-row1"
  }, _react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_MESSAGE,
    placement: "top",
    trigger: "hover"
  }, _react.default.createElement("div", {
    className: "pulse-announcement-message-product-name avatar-tooltip-label",
    ref: productRef
  }, _react.default.createElement("span", null, title), _react.default.createElement("span", {
    className: "pulse-announcement-message-eventtype"
  }, subtitle, pulseMessageObject.announcementid)), _react.default.createElement(_Tooltip.default, {
    style: showProductNameTooltip ? {
      visibility: 'visible',
      fontWeight: 'normal'
    } : {
      visibility: 'hidden'
    }
  }, _react.default.createElement("span", null, title), _react.default.createElement("span", {
    className: "pulse-announcement-message-eventtype"
  }, subtitle, pulseMessageObject.announcementid))), _react.default.createElement(TimeAgo, {
    createTimestamp: pulseMessageObject.createTimeStamp
  }));
};

var TimeAgo = function TimeAgo(props) {
  var createTimestamp = props.createTimestamp;
  return _react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_ACTIONS_BUTTON,
    placement: "left",
    trigger: "hover"
  }, _react.default.createElement("div", {
    className: "pulse-announcement-message-time-ago"
  }, _PulseUtil.default.formatTimeAgo(createTimestamp * 1000, true)), _react.default.createElement(_Tooltip.default, null, _PulseUtil.default.formatDate(createTimestamp * 1000)));
};

var RelatedAnnouncements = function RelatedAnnouncements(props) {
  var relatedannouncementMessageRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showRelatedMessageTooltip = _useState4[0],
      setshowRelatedMessageTooltip = _useState4[1];

  var mouseEnterHandler = function mouseEnterHandler() {
    setshowRelatedMessageTooltip(_PulseUtil.default.isTextOverFlown(relatedannouncementMessageRef));
  };

  var pulseMessageObject = props.pulseMessageObject,
      redirectToStatusSite = props.redirectToStatusSite,
      locale = props.locale;
  var relatedCount = pulseMessageObject.related.length;
  return _react.default.createElement(_Accordion.Accordion, {
    className: "pulse-announcement-accordian"
  }, _react.default.createElement(_Accordion.AccordionItem, {
    className: "pulse-announcement-related-accordion",
    header: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
      defaultMessage: "Show {relatedCount} Related",
      description: "Show Related",
      messageId: "ShowRelated",
      values: {
        relatedCount: relatedCount
      }
    }),
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }, pulseMessageObject.related.map(function (announcement, key) {
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    return _react.default.createElement("div", {
      className: "pulse-announcement-message-related-item",
      key: key,
      onClick: function onClick() {
        return redirectToStatusSite(pulseMessageObject);
      }
    }, _react.default.createElement(TimeAgo, {
      createTimestamp: announcement.createtimestamp
    }), _react.default.createElement(_OverlayTrigger.default, {
      delay: _Constants.TOOLTIP_DELAY_ON_MESSAGE,
      placement: "right",
      trigger: "hover"
    }, _react.default.createElement("div", {
      className: "pulse-announcement-message-row4",
      onMouseEnter: mouseEnterHandler,
      ref: relatedannouncementMessageRef
    }, _react.default.createElement(CombinedAnnouncementMessageAndImpactedServices, {
      locale: locale,
      message: announcement.message,
      pulseMessageObject: pulseMessageObject
    })), _react.default.createElement(_Tooltip.default, {
      style: showRelatedMessageTooltip ? {
        visibility: 'visible',
        fontWeight: 'normal'
      } : {
        visibility: 'hidden'
      }
    }, _react.default.createElement(CombinedAnnouncementMessageAndImpactedServices, {
      locale: locale,
      message: announcement.message,
      pulseMessageObject: pulseMessageObject
    }))));
  })));
};

var MessageFooter = function MessageFooter(props) {
  var pulseMessageObject = props.pulseMessageObject,
      redirectToStatusSite = props.redirectToStatusSite,
      locale = props.locale;
  return _react.default.createElement("div", {
    className: "pulse-announcement-message-row3"
  }, pulseMessageObject.related.length > 0 && _react.default.createElement(RelatedAnnouncements, {
    locale: locale,
    pulseMessageObject: pulseMessageObject,
    redirectToStatusSite: redirectToStatusSite
  }));
};

var CombinedAnnouncementMessageAndImpactedServices = function CombinedAnnouncementMessageAndImpactedServices(props) {
  var message = props.message,
      pulseMessageObject = props.pulseMessageObject,
      locale = props.locale;
  var localeData = localizationStrings;
  var impactedservicelist = [];
  pulseMessageObject.impactedservices.forEach(function (service, key) {
    impactedservicelist.push(_react.default.createElement("span", {
      className: "pulse-announcement-message-impacted-service",
      key: key
    }, "".concat(service).concat(pulseMessageObject.impactedservices.length - 1 == key ? '' : ',', " ")));
  });
  return _react.default.createElement("div", null, message, _react.default.createElement("br", null), impactedservicelist.length > 0 && _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localeData
  }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
    defaultMessage: "Capabilities Affected:",
    description: "CapabilitiesAffected",
    messageId: "CapabilitiesAffected"
  })), impactedservicelist);
};

var AnnouncementMessage = function AnnouncementMessage(props) {
  var message = props.message,
      pulseMessageObject = props.pulseMessageObject,
      locale = props.locale;
  var announcementMessageRef = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showAnnouncementMessageTooltip = _useState6[0],
      setshowAnnouncementMessageTooltip = _useState6[1];

  (0, _react.useEffect)(function () {
    setshowAnnouncementMessageTooltip(_PulseUtil.default.isTextOverFlown(announcementMessageRef));
  }, []);
  return _react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_MESSAGE,
    placement: "right",
    trigger: "hover"
  }, _react.default.createElement("div", {
    className: "pulse-announcement-message-row2-col2",
    ref: announcementMessageRef
  }, _react.default.createElement(CombinedAnnouncementMessageAndImpactedServices, {
    locale: locale,
    message: message,
    pulseMessageObject: pulseMessageObject
  })), _react.default.createElement(_Tooltip.default, {
    style: showAnnouncementMessageTooltip ? {
      visibility: 'visible',
      font: 'normal'
    } : {
      visibility: 'hidden'
    }
  }, _react.default.createElement(CombinedAnnouncementMessageAndImpactedServices, {
    locale: locale,
    message: message,
    pulseMessageObject: pulseMessageObject
  })));
};

exports.AnnouncementMessage = AnnouncementMessage;

var MessageBody = function MessageBody(props) {
  var pulseMessageObject = props.pulseMessageObject,
      locale = props.locale;
  return _react.default.createElement("div", {
    className: "pulse-announcement-message-row2"
  }, _react.default.createElement("div", {
    className: "pulse-announcement-message-row2-col1"
  }, _react.default.createElement(_OverlayTrigger.default, {
    delayShow: _Constants.TOOLTIP_DELAY_ON_AVATAR,
    placement: "top",
    trigger: "hover"
  }, _react.default.createElement("span", {
    className: "pulse-message-avatar"
  }, _react.default.createElement(_IconMapper.default, {
    product: pulseMessageObject.serviceName
  })), _react.default.createElement(_Tooltip.default, {
    className: "avatar-tooltip-label"
  }, pulseMessageObject.serviceName))), _react.default.createElement(AnnouncementMessage, {
    locale: locale,
    message: pulseMessageObject.messageContent,
    pulseMessageObject: pulseMessageObject
  }));
};

var PulseAnnouncementMessage = function PulseAnnouncementMessage(props) {
  var metrics = (0, _metrics.default)('exc.pulse.components.message.PulseAnnouncementMessage');
  var locale = props.locale,
      pulseMessageObject = props.pulseMessageObject;

  var getHrefForMessage = function getHrefForMessage(pulseMessageObject) {
    var url = new URL("".concat(_PulseApiHelper.default.getAdobeStatusHostUrl(), "/products/").concat(pulseMessageObject.productid, "?id=").concat(pulseMessageObject.announcementid));
    return url.href;
  };

  var redirectToStatusSite = function redirectToStatusSite(pulseMessageObject) {
    metrics.event('flyout.announcement.click', {
      region: window.config && window.config.region,
      category: pulseMessageObject.serviceName
    });
    window.open(getHrefForMessage(pulseMessageObject), '_blank');
  };

  return _react.default.createElement(_adobeIntlReact.default, {
    locale: locale,
    localeData: localizationStrings
  }, _react.default.createElement("div", {
    className: "pulse-announcement-message-root",
    onClick: function onClick() {
      return redirectToStatusSite(pulseMessageObject);
    }
  }, _react.default.createElement(MessageHeader, {
    pulseMessageObject: pulseMessageObject
  }), _react.default.createElement(MessageBody, {
    locale: locale,
    pulseMessageObject: pulseMessageObject
  }), _react.default.createElement(MessageFooter, {
    locale: locale,
    pulseMessageObject: pulseMessageObject,
    redirectToStatusSite: redirectToStatusSite
  })));
};

var _default = (0, _adobeIntlReact.withLocalization)(PulseAnnouncementMessage);

exports.default = _default;